import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function splitParagraphs(text: string): string[] {
  return text.split(/\n{2,}/);
}

export default function NextStep() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="border border-accent-500/20 bg-background-50 p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0 flex items-center gap-2">
            <span className="text-[13px] text-foreground-500 tracking-[0.08em] font-label whitespace-nowrap">
              {t('coursesMaster.nextStep.fromAdvanced')}
            </span>
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-arrow-right-line text-accent-500 text-lg"></i>
            </span>
            <span className="text-[13px] text-accent-600 tracking-[0.08em] font-label whitespace-nowrap">
              {t('coursesMaster.nextStep.toMaster')}
            </span>
          </div>
          <div className="flex-1 text-center md:text-left">
            {splitParagraphs(t('coursesMaster.nextStep.label')).map((paragraph, index) => (
              <p key={`label-${index}`} className="text-[13px] text-accent-600 tracking-[0.15em] mb-3 font-label">
                {paragraph}
              </p>
            ))}
            <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.06em] mb-3">
              {t('coursesMaster.nextStep.title')}
            </h3>
            {splitParagraphs(t('coursesMaster.nextStep.description')).map((paragraph, index) => (
              <p key={`description-${index}`} className="text-[16px] text-foreground-600 leading-relaxed tracking-[0.03em] mb-4">
                {paragraph}
              </p>
            ))}
            {splitParagraphs(
              t('coursesMaster.nextStep.discountLabel').replace('{amount}', t('coursesMaster.nextStep.discountAmount')),
            ).map((paragraph, index) => (
              <p key={`discount-${index}`} className="text-[15px] text-accent-700 font-medium tracking-[0.05em]">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="flex-shrink-0">
            <Link
              to="/courses/advanced"
              className="btn-glow inline-block px-6 py-3 border border-accent-500/50 text-accent-600 hover:text-accent-500 hover:border-accent-400 hover:bg-accent-500/5 text-[14px] tracking-[0.08em] text-center transition-all duration-300 whitespace-nowrap"
            >
              {t('coursesMaster.nextStep.viewAdvanced')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
